import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.user.farm');
import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'wiz-page-user-farm',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.user.farm/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageUserFarmComponent implements OnInit, OnDestroy {

    public type = 'dashboard';
    public farm_id = '';
    public farm: any = null;

    public ready = false;
    private destroy$ = new Subject<void>();
    private syncing = false;

    private allowedTypes = ['dashboard', 'info', 'cage', 'machine', 'check'];

    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) {}

    public async ngOnInit() {
        await this.service.init();
        const allowed = await this.service.auth.allow(true, '/auth/login');
        if (!allowed) return;

        await this.applyRoute();

        this.ready = true;
        await this.service.render();

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntil(this.destroy$)
        ).subscribe(async () => {
            await this.applyRoute();
            await this.service.render();
        });
    }

    public ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private async applyRoute() {
        if (this.syncing) return;
        this.syncing = true;

        try {
            let nextType = WizRoute.segment.type || 'dashboard';
            if (!this.allowedTypes.includes(nextType)) {
                nextType = 'dashboard';
            }

            const nextFarmId = WizRoute.segment.farm_id || '';

            const farmChanged = this.farm_id !== nextFarmId;
            this.type = nextType;

            if (!farmChanged && this.farm) {
                return;
            }

            const { code, data } = await wiz.call('farm_info', {
                farm_id: nextFarmId
            });

            if (code !== 200 || !data?.id) {
                this.farm = null;
                return;
            }

            const normalizedFarmId = String(data.id);
            this.farm = data;
            this.farm_id = normalizedFarmId;

            const targetUrl = `/user/farm/${this.type}/${this.farm_id}`;
            const currentUrl = this.router.url.split('?')[0];

            if (String(nextFarmId) !== normalizedFarmId && currentUrl !== targetUrl) {
                await this.router.navigateByUrl(targetUrl);
            }
        } finally {
            this.syncing = false;
        }
    }
}

export default PageUserFarmComponent;